/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleBookingResponseStatus } from './VehicleBookingResponseStatus';
import {
    VehicleBookingResponseStatusFromJSON,
    VehicleBookingResponseStatusFromJSONTyped,
    VehicleBookingResponseStatusToJSON,
    VehicleBookingResponseStatusToJSONTyped,
} from './VehicleBookingResponseStatus';
import type { VehicleSummary } from './VehicleSummary';
import {
    VehicleSummaryFromJSON,
    VehicleSummaryFromJSONTyped,
    VehicleSummaryToJSON,
    VehicleSummaryToJSONTyped,
} from './VehicleSummary';

/**
 * 
 * @export
 * @interface VehicleBookingResponse
 */
export interface VehicleBookingResponse {
    /**
     * Gondola internal booking ID
     * @type {number}
     * @memberof VehicleBookingResponse
     */
    bookingId?: number;
    /**
     * User-facing confirmation number
     * @type {string}
     * @memberof VehicleBookingResponse
     */
    gondolaBookingId?: string;
    /**
     * Travelport Universal Record locator
     * @type {string}
     * @memberof VehicleBookingResponse
     */
    providerBookingId?: string;
    /**
     * 
     * @type {VehicleBookingResponseStatus}
     * @memberof VehicleBookingResponse
     */
    status: VehicleBookingResponseStatus;
    /**
     * 
     * @type {VehicleSummary}
     * @memberof VehicleBookingResponse
     */
    vehicle?: VehicleSummary;
    /**
     * 
     * @type {Error}
     * @memberof VehicleBookingResponse
     */
    error?: Error;
    /**
     * When error.code is LOYALTY_NUMBER_REJECTED, the id of the loyalty account whose membership number the vendor rejected. Clients use it to open the correct account's editor so the user fixes the number that actually failed (incl. auto-detected or cross-brand attachments that differ from the UI selection).
     * @type {string}
     * @memberof VehicleBookingResponse
     */
    rejectedLoyaltyAccountId?: string;
}



/**
 * Check if a given object implements the VehicleBookingResponse interface.
 */
export function instanceOfVehicleBookingResponse(value: object): value is VehicleBookingResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function VehicleBookingResponseFromJSON(json: any): VehicleBookingResponse {
    return VehicleBookingResponseFromJSONTyped(json, false);
}

export function VehicleBookingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
        'providerBookingId': json['provider_booking_id'] == null ? undefined : json['provider_booking_id'],
        'status': VehicleBookingResponseStatusFromJSON(json['status']),
        'vehicle': json['vehicle'] == null ? undefined : VehicleSummaryFromJSON(json['vehicle']),
        'error': json['error'] == null ? undefined : json['error'],
        'rejectedLoyaltyAccountId': json['rejected_loyalty_account_id'] == null ? undefined : json['rejected_loyalty_account_id'],
    };
}

export function VehicleBookingResponseToJSON(json: any): VehicleBookingResponse {
    return VehicleBookingResponseToJSONTyped(json, false);
}

export function VehicleBookingResponseToJSONTyped(value?: VehicleBookingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'gondola_booking_id': value['gondolaBookingId'],
        'provider_booking_id': value['providerBookingId'],
        'status': VehicleBookingResponseStatusToJSON(value['status']),
        'vehicle': VehicleSummaryToJSON(value['vehicle']),
        'error': value['error'],
        'rejected_loyalty_account_id': value['rejectedLoyaltyAccountId'],
    };
}

